import { RouteObject } from 'react-router-dom';

import { Home, Signup, Tournois,  Connexion, ForgotPassword, ResetPassword, Partenaires, Messages, Compte, Politique, Contact, Premium, AboSuccess, Annonces, Unsubscribe } from '../pages';
import React from 'react';
import ProtectedRoute from '../components/protectedroute';
import Terms from '../pages/terms';
import AboCancel from '../pages/abocancel';



// Chargement des composants avec React.lazy pour le code splitting

const siteRoutes: RouteObject[] = [
  {
    path: '/',
    index: true,
    element: React.createElement(Partenaires),
  },
  {
    path: '/tournois',
    element: React.createElement(Tournois),
  },    
  {
      path: '/partenaires',         
      element: React.createElement(Partenaires)   
  },
  {
    path: '/annonces',
    element: React.createElement(ProtectedRoute, {
        children: React.createElement(Annonces)
    }),
  },
  {
      path: '/messages',
      element: React.createElement(ProtectedRoute, {
          children: React.createElement(Messages)
      }),
  },     
  {
      path: '/compte',
      element: React.createElement(ProtectedRoute, {
          children: React.createElement(Compte)
      }),
  },
  {
    path: '/signup',
    element: React.createElement(Signup),
  },
  {
    path: '/login',
    element: React.createElement(Connexion),
  },
  {
    path: '/politique',
    element: React.createElement(Politique),
  },
  {
    path: '/about',
    element: React.createElement(Home),
  },
  {
    path: '/terms',
    element: React.createElement(Terms),
  },
  {
    path: '/contact',
    element: React.createElement(Contact),
  },  
  {
    path: '/premium',
    element: React.createElement(Premium),
  },
  {
    path: '/forgot-password',
    element: React.createElement(ForgotPassword),
  },
  {
    path: '/reset-password',
    element: React.createElement(ResetPassword),
  },
  {
    path: '/abosuccess',
    element: React.createElement(AboSuccess),
  },
  {
    path: '/abocancel',
    element: React.createElement(AboCancel),
  },
  {
    path: '/unsubscribe/:token',
    element: React.createElement(Unsubscribe),
  }
  
];

export default siteRoutes;
